import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ic_top",
  "use": "icon-ic_top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ic_top\">\r\n\t<path d=\"M557.654996 981.669904c-6.499999 59.041994-88.986991 53.776995-92.179991 0-0.083-40.896996-0.083-641.390937-0.083-641.390937l-283.839972 273.963973c-44.472996 38.308996-97.43499-22.922998-64.344994-63.215994 125.709988-121.895988 351.289966-340.004967 356.507965-345.049966 20.810998-22.608998 53.572995-23.779998 75.721993 0 41.406996 40.037996 348.700966 336.328967 358.028965 346.989966 31.166997 38.741996-19.223998 96.073991-62.242994 63.773994C834.109969 607.310941 557.739996 340.267967 557.739996 340.267967M116.396039 3.332l786.487923 0 0 89.285991L116.396039 92.617991 116.396039 3.332z\" p-id=\"3466\">\r\n\t</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ic_top.svg
// module id = yyts
// module chunks = 15